import React from 'react';
import { useSelector } from "react-redux";
import {
  CRow,
  CCol,
  CLabel,
  CInput,
} from "@coreui/react";

const Recr = (props) => {
  const { handleInputChange } = props;
  const { insert, main } = useSelector((state) => state);

  {/* 22/11/29 메가인포 도입자명, 도입자직위, 도입자연락처 사용X */}
  return (
    <>
      <CRow>
        {/* {main.corpNm == "megainfo" &&
          <>
          <CCol xs="12" md="6" className="text-left mb-2">
            <CLabel>
              <span>*</span>도입자사번
            </CLabel>
            <CInput
              type="text"
              id="recrEmpNo"
              name="recrEmpNo"
              value={insert.reqTaskInfo.recrEmpNo || ""}
              maxLength="25"
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CCol>
          </>  
        } */}
        <CCol xs="12" md="6" className="text-left mb-2">
          <CLabel>
            <span>{(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA") ? '' : '*'}</span>
            {main.corpNm == "megainfo" ? '증원자명(소개자 명)' :( main.corpNm == "metarich" || main.corpNm == "LS-FC" || main.corpNm == "LS-EFA" ) ? '유치자명' : '도입자명'}
          </CLabel>
          <CInput
            type="text"
            id="recrNm"
            name="recrNm"
            value={insert.reqTaskInfo.recrNm || ""}
            maxLength="25"
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          />
        </CCol>
        {(main.corpNm != "megainfo" && main.corpNm != "metarich"&& main.corpNm != "sky") &&
          <>
          <CCol xs="12" md="6" className="text-left mb-2">
            <CLabel>
               {(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA") ? '유치자직위' : '도입자직위'}
            </CLabel>
            <CInput
              type="text"
              id="recrOflv"
              name="recrOflv"
              value={insert.reqTaskInfo.recrOflv || ""}
              maxLength="10"
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CCol>
          <CCol xs="12" md="6" className="text-left mb-2">
            <CLabel>
              {(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA") ? '유치자연락처' : '도입자연락처'}
            </CLabel>
            <CInput
              type="text"
              id="recrTel"
              name="recrTel"
              value={insert.reqTaskInfo.recrTel || ""}
              maxLength="13"
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CCol>
          </>
        }
        {/* 리더스 도입자 사번 */}
        {(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA") &&
          <>
          <CCol xs="12" md="6" className="text-left mb-2">
            <CLabel>
                유치자사번
            </CLabel>
            <CInput
              type="text"
              id="recrEmpNo"
              name="recrEmpNo"
              value={insert.reqTaskInfo.recrEmpNo || ""}
              maxLength="25"
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CCol>
          </> 
        }
      </CRow>
    </>
  )
}

export default React.memo(Recr);